import React, { useEffect } from "react";
import { useState } from "react";
import Sidemenu from "../../components/sidemenu";
import RequestCard from "./components/requestCard";
import Dropdown from '../../components/elements/dropdown';
import { useNavigate } from "react-router-dom";
import { HeadDiv,Heading,MainContainer,MainDiv,ColumnDiv,PaginationContainer, Button } from "./styled";
import { functionService } from "../../lib/functions";
import { Pagination } from "antd";



const Coffeeeplus = () => {
  let navigate = useNavigate();
  const [candidateList, setCandidateList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [approvedByAdmin, setApprovedByAdmin] = useState(null);
  const [selectedShortlistType, setSelectedShortlistType] = useState('');
  const [searchStatus, setSearchStatus] = useState('ALL');
  const shortlistStatusList = [
    {
      name: "Uploaded/Created Shortlists",
      byAdmin: true
    },
    {
      name: "Requested Shortlists",
      byAdmin: false
    }
  ];

  const searchStatusList = [
    {
      name : 'CONFIRMED',
      value : 'CONFIRMED'
    },
    {
      name : 'DRAFTED',
      value : 'DRAFTED'
    },
    {
      name : 'REQUESTED',
      value : 'REQUESTED'
    },
    {
      name : 'REJECTED',
      value : 'REJECTED'
    }
  ];

  const getCandidateList = async ({ page }) => {
    const { status, response } = await functionService.get(
      `recruiter/get-all-searches?pageNo=${page}&searchStatus=${searchStatus}&approvedByAdmin=${approvedByAdmin}`
    );
    if (status) {
        setCandidateList(response?.data?.data?.candidateSearch || []);
        setTotalPage(response?.data?.data?.totalCount || 0);
    }
    else {
      setCandidateList([]);
      setTotalPage(0);
    }
  };
  useEffect(() => {
    getCandidateList({ page });
  }, [page, approvedByAdmin, searchStatus]);

  const selectShortlistType = (shortlistType, status) => {
    // console.log(shortlistType, status);
    setSelectedShortlistType(shortlistType);
    setApprovedByAdmin(status);
  }

  const selectSearchStatus = (name, searchStatus) => {
    // console.log('name=========>',name, 'searchStatus=======>',searchStatus);
    setSearchStatus(searchStatus);
  }

  return (
    <MainDiv>
      <Sidemenu collapsed={false} />

      <ColumnDiv>
      <HeadDiv>
        <Heading>Candidates Request</Heading>
        <Button
          style={{
            fontFamily: 'inter',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '14.52px',
            color: '#1B49EA',
            background: '#FFF',
            border: '1px solid #1B49EA',
            borderRadius: '6px'
          }}
          onClick={() => {navigate("/candidateRequest/upload-shortlist", { replace: true })}}
          >
          Upload Shortlist
        </Button>
      </HeadDiv>
        <MainContainer>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '510px'}}>
          <Dropdown
            title="Select Shortlist Type"
            list={shortlistStatusList}
            value="byAdmin"
            name="name"
            selected={selectShortlistType}
            width="250px"
            height="40px"
            option="name"
            active = {selectedShortlistType}
            addAll
          />

          <Dropdown
            title="Select Shortlist Status"
            list={searchStatusList}
            value="value"
            name="name"
            selected={selectSearchStatus}
            width="250px"
            height="40px"
            option="name"
            active = {searchStatus}
            addAll
          />
        </div>
          {candidateList.map((item) => {
            return (
              item.recruiter_id&&<RequestCard
                item={{
                  setCandidateList: setCandidateList,
                  request_status: item.request_status,
                  id: item.search_id,
                  recruiting_role_title: item.role,
                  no_of_candidate: item.total_shortlisted,
                  job_loc: item.job_loc,
                  experience_min: item.experience_min,
                  experience_max: item.experience_max,
                  no_position: item.no_position,
                  role_type: item.role_type,
                  job_loc_type: item.job_loc_type,
                  created_at: item.created_at,
                  recruiter_name: item.recruiter_name,
                  company_name: item.company_name,
                  recruiter_id: item.recruiter_id,
                  search_id: item.search_id,
                  role_requirements:item.role_requirements,
                  project_type:item.project_type,
                  year_of_exp:item.year_of_exp
                }}
              />
            );
          })}
        </MainContainer>
        <PaginationContainer>
          <Pagination
            defaultCurrent={page}
            total={totalPage}
            onChange={(currentPage) => {
              setPage(currentPage - 1);
            }}
            showSizeChanger={false}
          />
        </PaginationContainer>
      </ColumnDiv>
    </MainDiv>
  );
};

export default Coffeeeplus;
